import { render, staticRenderFns } from "./ArticlesWarehouse2.vue?vue&type=template&id=5690a870&scoped=true"
import script from "./ArticlesWarehouse2.vue?vue&type=script&lang=js"
export * from "./ArticlesWarehouse2.vue?vue&type=script&lang=js"
import style0 from "./ArticlesWarehouse2.vue?vue&type=style&index=0&id=5690a870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5690a870",
  null
  
)

export default component.exports